import { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const GasSavings = forwardRef<SVGElement, OwnProps>(props => {
  return (
    <svg
      width="51"
      height="52"
      viewBox="0 0 51 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 46.5007H2V47.5007H3V46.5007ZM29 26.4749C29 27.0272 29.4477 27.4749 30 27.4749C30.5523 27.4749 31 27.0272 31 26.4749H29ZM10 2.50073H23V0.500732H10V2.50073ZM4 46.5007V8.50073H2V46.5007H4ZM29 8.50073V26.4749H31V8.50073H29ZM24.1563 45.5007H3V47.5007H24.1563V45.5007ZM23 2.50073C26.3137 2.50073 29 5.18702 29 8.50073H31C31 4.08245 27.4183 0.500732 23 0.500732V2.50073ZM10 0.500732C5.58172 0.500732 2 4.08245 2 8.50073H4C4 5.18702 6.68629 2.50073 10 2.50073V0.500732Z"
        fill="#00619E"
      />
      <rect
        x="9"
        y="8.50073"
        width="15"
        height="11"
        rx="2"
        stroke="#00619E"
        strokeWidth="2"
      />
      <path
        d="M1 46.5007H25"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16.6386 38.5007H16.3613C14.5049 38.5007 13 36.9958 13 35.1394C13 34.6219 13.1195 34.1115 13.3491 33.6478L16.3456 27.5966C16.3746 27.5379 16.4345 27.5007 16.5 27.5007C16.5655 27.5007 16.6253 27.5379 16.6544 27.5966L19.6508 33.6478C19.8805 34.1115 19.9999 34.6219 19.9999 35.1394C19.9999 36.9958 18.495 38.5007 16.6386 38.5007Z"
        stroke="#00619E"
        strokeWidth="2"
      />
      <path
        d="M31 16.5007H33C34.1046 16.5007 35 17.3962 35 18.5007V20.0007C35 21.3814 36.1193 22.5007 37.5 22.5007V22.5007C38.8807 22.5007 40 21.3814 40 20.0007V14.5007C40 12.8439 41.3431 11.5007 43 11.5007H46"
        stroke="#00619E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.3333 39.5007L39 43.1674L47.5363 32.5625C49.0766 34.4553 50 36.8702 50 39.5007C50 45.5759 45.0751 50.5007 39 50.5007C32.9249 50.5007 28 45.5759 28 39.5007C28 33.4256 32.9249 28.5007 39 28.5007C39.9496 28.5007 40.871 28.6211 41.75 28.8473"
        stroke="#00AED9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default GasSavings;
